import { Field, Form, FormikProps } from 'formik';
import { FormValues } from './types';
import styles from './ReportModal.module.css';
import { FormikDateRangePicker } from '../Forms/Components/DateRangePicker';
import { FormikRadioGroupInput } from '../Forms/Components/RadioGroup';

type OrdersWithoutChargesProps = FormikProps<FormValues> & {
	id: string;
};

export default function OrdersWithoutChargesForm({ id }: OrdersWithoutChargesProps) {
	return (
		<Form
			className={styles['report-form']}
			id={id}
		>
			<div className={styles['flex-row']}>
				<Field
					name='reportDateRange'
					component={FormikDateRangePicker}
					label='Date Range'
					className={styles['date-range-input']}
				/>
			</div>
			<div className={styles['flex-row']}>
				<Field
					component={FormikRadioGroupInput}
					name='accept'
					label='Report Format:'
					labelPlacement='top'
					defaultOptionSelected='HTML'
					radioItems={['HTML', 'Excel']}
				/>
			</div>
		</Form>
	);
}
